import React from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'
import { IconButton, makeStyles } from '@material-ui/core'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { useTrans } from '../../../../services/i18n'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 16,
  },
  label: { fontSize: 16, fontWeight: 700, color: '#0d0d0d' },
  nav: { display: 'flex', gap: 8 },
  navButton: {
    width: 32,
    height: 32,
    padding: 4,
    border: '1px solid #eaeef6',
    borderRadius: 8,
    color: '#0d0d0d',
  },
})

const MonthNav = ({ month, onPrev, onNext }) => {
  const { trans } = useTrans()
  const styles = useStyles()
  return (
    <div className={styles.root}>
      <span className={styles.label}>{dayjs(`${month}-01`).format('MMMM YYYY')}</span>
      <div className={styles.nav}>
        <IconButton className={styles.navButton} aria-label={trans('previous-month')} onClick={onPrev}>
          <ChevronLeftIcon fontSize="small" />
        </IconButton>
        <IconButton className={styles.navButton} aria-label={trans('next-month')} onClick={onNext}>
          <ChevronRightIcon fontSize="small" />
        </IconButton>
      </div>
    </div>
  )
}

MonthNav.propTypes = {
  month: PropTypes.string.isRequired,
  onPrev: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
}

export default MonthNav
